var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"abc"},_vm._l((_vm.arr_ru),function(item,key){return _c('li',{key:`abc${key}`,class:{'active' : item ? item.toUpperCase() === _vm.getLetter : item === _vm.getLetter},on:{"click":function($event){return _vm.setFilter(key)}}},[_vm._v(" "+_vm._s(item ? item : _vm.$store.getters.GET_LANG ? 'все' : 'all')+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }